export const inputFieldsAddresses = [
    { name: "ftm_street_address", label: "Street address", placeholder: "Street address", type: "text", hidden: false },
    { name: "ftm_place", label: "City", placeholder: "City", type: "text", hidden: false },
    { name: "ftm_postcode", label: "Postcode", placeholder: "Postcode", type: "text", hidden: false },
    { name: "ftm_latitude", label: "", placeholder: "Latitude", type: "text", hidden: true },
    { name: "ftm_longitude", label: "", placeholder: "lngitude", type: "text", hidden: true },
];

export const inputFieldsLicenceAndVehicleDetails = [
    { name: "ftm_driving_license_number", label: "Driving licence number", placeholder: "Driving licence number", type: "text" }
];

export const nextOfKinDetails = [
    { name: "ftm_next_of_kin", label: "Emergency contact name ", placeholder: "Emergency contact name", type: "text" }
];

export const taxAndInsuranceDetails = [
    { name: "ftm_utr_number", label: "Personal UTR number", placeholder: "Personal UTR number", type: "text" },
    { name: "ftm_ni_number", label: "NI number", placeholder: "NI number", type: "text" },
];

export const businessDetails = [
    { name: "ftm_business_utr_number", label: "Business UTR number", placeholder: "Business UTR number", type: "text" },
    { name: "ftm_name_of_business", label: "Business name", placeholder: "Business name", type: "text" },
    { name: "ftm_company_reg_number", label: "Business registration number", placeholder: "Business registration number", type: "text" },
];

export const bankDetails = [
    { name: "ftm_bank_name", label: "Bank name", placeholder: "Bank name", type: "text" }
];